
import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import {formatDate} from "../../../../../../../../util/Helpers"
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";

const ViewSavedCardModal = ({showViewSavedCardModal, details, onHide}) => {

  return (
    <Modal
        show={showViewSavedCardModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
      
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")}
                />
            </span>
            Card Details
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body 
            className="px-10 py-2"
        >   
            <div className="row">
                <div className="col-lg-7 py-4">
                    <h6 className=" px">Card Id</h6>
                    <span className="text-muted">{details?.cardId}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bank</h6>
                    <span className="text-muted">{details?.bank}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Card Type</h6>
                    <span className="text-muted">{details?.cardType}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bin</h6>
                    <span className="text-muted">{details?.bin}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Last4</h6>
                    <span className="text-muted">{details?.last4}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Expire</h6>
                    <span className="text-muted">{details?.expire}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Gateway</h6>
                    <span className="text-muted">{details?.gateway}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Country Code</h6>
                    <span className="text-muted">{details?.countryCode}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Email</h6>
                    <span className="text-muted">{details?.email}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Created At</h6>
                    <span className="text-muted">{formatDate(details?.createdAt)}</span>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
      </Modal>

        );
}

export default ViewSavedCardModal;